import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { put, select } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import { getGallectionById } from '../selectors';
import { normalizeGallection } from '../../redux/normalizr/helpers';
function* setGallectionPrice(action) {
    const { folderId, pointsPrice } = action.payload;
    const gallection = yield select(getGallectionById, folderId);
    if (!gallection) {
        return;
    }
    const updatedGallection = _object_spread_props(_object_spread({}, gallection), {
        premiumFolderData: _object_spread_props(_object_spread({
            type: 'paid',
            hasAccess: true
        }, gallection.premiumFolderData), {
            pointsPrice
        })
    });
    const entities = normalizeGallection(updatedGallection);
    yield put(putEntities({
        entities
    }));
}
export default setGallectionPrice;
